import { render } from "./KPIItem.vue?vue&type=template&id=ee5e4da6&scoped=true"
import script from "./KPIItem.vue?vue&type=script&lang=js"
export * from "./KPIItem.vue?vue&type=script&lang=js"

import "./KPIItem.vue?vue&type=style&index=0&id=ee5e4da6&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee5e4da6"]])

export default __exports__